import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AdminContextService } from '../services/admin.context.service';
import { CohortDO } from '../domain-model-dtos';
import { isDefined } from '../../components/utils/utils';

@Injectable()
export class AdminContextInterceptor implements HttpInterceptor {
  currentCohort: CohortDO;

  constructor(private adminContextService: AdminContextService) {
    adminContextService.getCohortWatcher().subscribe((cohort: CohortDO) => {
      this.currentCohort = cohort;
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.appendParams(req));
  }

  private appendParams(req: HttpRequest<any>) {
    return isDefined(this.currentCohort)
      ? req.clone({
          headers: req.headers.set('cohort-id', `${this.currentCohort.id}`),
        })
      : req;
  }
}
